import React from 'react';
import { motion } from 'framer-motion';
export const MethodSection = () => {
  const features = [{
    image: 'https://cdn.magicpatterns.com/uploads/8tUJZn2NeoWdV5TPdxTy1Q/FOTO_1.png',
    title: 'Rápido y Efectivo',
    desc: 'Resultados desde la primera sesión.'
  }, {
    image: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=400&h=300&fit=crop',
    title: 'Sin Sufrimiento',
    desc: 'No necesitas revivir el trauma para sanarlo.'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/fPRS4hRHkQpGgdTjACr975/FOTO_2.jpg',
    title: 'Científicamente Respaldado',
    desc: 'Creado por Ricardo Eiriz.'
  }];
  const stats = ['+8k Participantes', '40+ Países', '+3k Facilitadores', '100% Garantía de Método'];
  return <section id="method" className="py-24 bg-white overflow-hidden" data-id="element-71">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-73">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6 leading-tight" data-id="element-74">
            Método INTEGRA®:{' '}
            <span className="text-accent" data-id="element-75">Ciencia y Conexión.</span>
          </h2>
          <p className="text-lg md:text-xl text-primary/80 max-w-3xl mx-auto leading-relaxed" data-id="element-76">
            Es el lenguaje de programación para tu mente subconsciente. Basado
            en los últimos descubrimientos de la física cuántica, neurociencia y
            epigenética.
          </p>
        </motion.div>

        {/* Three pillars with images */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-77">
          {features.map((feature, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.15
        }} className="bg-soft/15 rounded-3xl overflow-hidden border border-soft/30 group hover:shadow-xl transition-all duration-300" data-id="element-78">
              <div className="h-48 overflow-hidden" data-id="element-79">
                <img src={feature.image} alt={feature.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-80" />
              </div>
              <div className="p-6 text-center" data-id="element-81">
                <h3 className="text-xl font-bold text-primary mb-2" data-id="element-82">
                  {feature.title}
                </h3>
                <p className="text-primary/70" data-id="element-83">{feature.desc}</p>
              </div>
            </motion.div>)}
        </div>

        {/* Stats */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-84">
          <div className="bg-primary rounded-3xl p-10 text-white shadow-2xl relative overflow-hidden" data-id="element-85">
            <div className="absolute -top-24 -right-24 w-64 h-64 bg-accent/20 rounded-full blur-3xl" data-id="element-86"></div>
            <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-accent/20 rounded-full blur-3xl" data-id="element-87"></div>

            <div className="relative z-10 grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-88">
              {stats.map((stat, idx) => {
              const [number, ...textParts] = stat.split(' ');
              const text = textParts.join(' ');
              return <div key={idx} className="text-center" data-id="element-89">
                    <div className="text-3xl md:text-4xl font-bold text-accent mb-2" data-id="element-90">
                      {number}
                    </div>
                    <div className="text-base md:text-lg font-medium text-white/90" data-id="element-91">
                      {text}
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};